import { db } from "../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";

export default async function sendEmail(recipients, subject, body) {
  await addDoc(collection(db, "outbox"), {
    to: recipients,
    message: { subject: subject, text: body },
  });
}
